import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { SessionInterceptor } from './auth/session.interceptor';
import { ConfirmDialogComponent } from './common/confirm-dialog/confirm-dialog.component';
import { MaterialModule } from '../common/material/material.module';
import { EmailTemplateDialogComponent } from './common/email-template-dialog/email-template-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';

@NgModule(
    {
        declarations: [
            ConfirmDialogComponent,
            EmailTemplateDialogComponent,
        ], imports: [
            CommonModule,
            MaterialModule,
            MatDialogModule,
        ], providers: [
            {
                provide: HTTP_INTERCEPTORS,
                useClass: SessionInterceptor,
                multi: true,
            },
            provideHttpClient(withInterceptorsFromDi()),
        ],
    })
export class ServiceModule {
}
